import { render, staticRenderFns } from "./payee_company_detail.vue?vue&type=template&id=63a6f1ae&scoped=true"
import script from "./payee_company_detail.vue?vue&type=script&%3Aroute=%7Bpath%3A%20'%2Ffin%2Fcomponents%2Fpayee_company_detail'%2CnoChkout%3A%20true%2C%7D&lang=js"
export * from "./payee_company_detail.vue?vue&type=script&%3Aroute=%7Bpath%3A%20'%2Ffin%2Fcomponents%2Fpayee_company_detail'%2CnoChkout%3A%20true%2C%7D&lang=js"
import style0 from "./payee_company_detail.vue?vue&type=style&index=0&id=63a6f1ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a6f1ae",
  null
  
)

export default component.exports